import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.state';
import { UserSession } from '../models/user-session.model';
import { OfflineStorageService } from './offline-storage.service';
import { BEARER_ONLY } from '../interceptor/token.interceptor';

const USER_SESSION = 'userSession';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  // Init with null to filter out the first value in a guard!
  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  timeoutInterval: any;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private offlineStorageService: OfflineStorageService
  ) { }

  login(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/auth/mobile-login', JSON.stringify(item), {withCredentials: true});
  }

  formatUser(data: any) {
    const userSession = new UserSession(
      data.token, // idToken
    );
    return userSession;
  }

  async setUserSession(userSession: UserSession) {
     console.log('setUserSession', userSession)
    this.offlineStorageService.setObject(USER_SESSION, userSession);
    // this.runTimeoutInterval(userSession);
  }

  runTimeoutInterval(userSession: UserSession) {
    // const todayDate = new Date().getTime();
    // const expirationDate = userSession.expiration_date.getTime();
    // const timeInterval = expirationDate - todayDate;
    // console.log({timeInterval});
    // this.timeoutInterval = setTimeout(() => {
    //   window.dispatchEvent(new CustomEvent('auth:timeout', { detail: true}));  
    // }, timeInterval);
  }

  forgotPassword(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/auth/forgot-password', JSON.stringify(item), {withCredentials: true});
  }

  resetPassword(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/auth/reset-password', JSON.stringify(item), {withCredentials: true});
  }

  sendPasswordResetCode(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/public/app-password/send-code', JSON.stringify(item), {withCredentials: true});
  }

  resetPasswordWithCode(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/public/app-password/reset', JSON.stringify(item), {withCredentials: true});
  }

  async getUserSession() {
    const userSessionLocal: any = await this.offlineStorageService.getObject(USER_SESSION);
    console.log({userSessionLocal})
    if (userSessionLocal) {
      const userSession = new UserSession(
        userSessionLocal.userToken,
      );
      this.runTimeoutInterval(userSession);
      return userSession;
    }
    return null;
  }


  async logout() {
    await this.offlineStorageService.removeItem(USER_SESSION);
    if (this.timeoutInterval) {
      clearTimeout(this.timeoutInterval);
      this.timeoutInterval = null;
    }
  }
}
